<div class="incident-page min-vh-100 d-flex flex-column bg-transparent">
  <HomeNavBar />

  <section class="incident-feed-shell">
    <div class="container-fluid flex-grow-1">
      <div class="row gap-2 mt-2">

        <div class="col bg-transparent m-0 gap-2 rounded p-1">

          <div class="px-0 px-md-3 pb-3 scrollable-container h-100">
            <div class="row gx-4 justify-content-between pb-extra pb-extra-desktop">

              <aside class="d-none d-xl-block col-xl-3 incident-profile-column">
                <div class="home-profile-rail incident-profile-rail">
                  <div class="home-profile-rail-dots">
                    <span></span>
                  </div>
                  <div class="home-profile-identity d-flex flex-column align-items-center text-align-center">
                    <div class="home-profile-art" aria-hidden="true">
                      <i class="bi bi-shield-exclamation"></i>
                    </div>
                    <div class="home-profile-avatar">
                      <img v-if="profileImage" :src="profileImage" alt="Profile">
                      <span v-else>{{ incident_profile_name.charAt(0) }}</span>
                    </div>
                    <h6 class="fw-bold">{{ incident_profile_name }}</h6>
                    <p>{{ incident_profile_handle }}</p>
                  </div>

                  <nav class="home-profile-menu" aria-label="Incident shortcuts">
                    <div v-for="item in incident_left_nav_items" :key="item.label">
                      <a v-if="item.href" :href="item.href" class="home-profile-menu-item"
                        :class="{ active: item.active }">
                        <i class="bi" :class="item.icon"></i>
                        <span>{{ item.label }}</span>
                      </a>
                      <button v-else type="button" class="home-profile-menu-item" :class="{ active: item.active }"
                        @click="handle_incident_left_nav_action(item)">
                        <i class="bi" :class="item.icon"></i>
                        <span>{{ item.label }}</span>
                      </button>
                    </div>
                  </nav>
                </div>
              </aside>

              <div class="col-12 col-lg-9 col-xl-9">
                <!-- PAGE HEADER -->
                <div class="incident-feed-toolbar d-flex justify-content-between align-items-center gap-3 mb-3">

                  <div class="incident-composer-card card border rounded-4 p-1" data-bs-toggle="modal" data-bs-target="#incidentModal">
                    <div class="feed-composer-row rounded d-flex align-items-center gap-3">
                      <div class="feed-composer-avatar">
                        <img :src="profileImage || require('@/assets/images/user.png')" alt="Profile">
                      </div>
                      <button type="button" class="feed-composer-prompt text-xxs flex-grow-1" aria-label="Create a post"
                        data-bs-toggle="modal" data-bs-target="#incidentModal">
                        <span>Report an incident or concern, {{ composer_display_name }}.</span>
                      </button>
                      <div class="feed-composer-actions d-none d-sm-flex">
                        <button type="button" class="feed-composer-action feed-composer-action-recording"
                          data-bs-toggle="modal" data-bs-target="#incidentModal" title="Recording">
                          <i class="bi bi-mic-fill action-icon"></i>
                        </button>
                        <button type="button" class="feed-composer-action feed-composer-action-media"
                          data-bs-toggle="modal" data-bs-target="#incidentModal" title="Images">
                          <i class="bi bi-image-fill action-icon"></i>
                        </button>
                        <button type="button" class="feed-composer-action feed-composer-action-video"
                          data-bs-toggle="modal" data-bs-target="#incidentModal" title="Video">
                          <i class="bi bi-play-btn-fill action-icon"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Right Controls -->
                  <div class="incident-toolbar-actions d-flex align-items-center gap-2">
                    <button
                      class="incident-icon-button btn btn-light border rounded-3 d-lg-none d-flex align-items-center justify-content-center position-relative"
                      type="button" title="Show incident map" @click="toggle_map">
                      <i class="bi bi-geo-alt-fill"></i>
                    </button>

                    <!-- Filter Dropdown -->
                    <div class="position-relative me-2" ref="incidentFilterDropdownRef">
                      <div class="d-flex align-items-center gap-1">
                        <button
                          class="incident-icon-button btn btn-light border rounded-4 d-flex align-items-center justify-content-center position-relative"
                          @click="filter_dropdown_open = !filter_dropdown_open" title="Filter incidents">
                          <i class="bi bi-funnel-fill"></i>

                          <span v-if="active_filter_count > 0"
                            class="incident-filter-count position-absolute top-0 start-100 translate-middle badge rounded bg-primary">
                            {{ active_filter_count }}
                          </span>
                        </button>
                      </div>
                      <!-- Dropdown -->
                      <div v-if="filter_dropdown_open"
                        class="incident-filter-dropdown position-absolute top-100 end-0 bg-white shadow rounded p-3 mt-2">

                        <!-- Header -->
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <span class="fw-600 text-sm">Filter Reports</span>

                          <div class="d-flex gap-2 align-items-center">
                            <button v-if="active_filter_count > 0" class="btn btn-link btn-sm text-danger p-0 text-xs"
                              @click="clear_all_filters">
                              Clear all
                            </button>

                            <button class="btn btn-sm btn-light px-2 py-1 incident-filter-close"
                              @click="filter_dropdown_open = false">
                              <i class="bi bi-x-lg"></i>
                            </button>
                          </div>
                        </div>

                        <!-- Search -->
                        <div class="mb-3">
                          <label class="text-xxs fw-600 text-uppercase text-muted mb-1 d-block">
                            Search
                          </label>

                          <div class="position-relative">
                            <i
                              class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-2 text-muted"></i>

                            <input v-model="search_query" type="text" class="form-control form-control-sm ps-4 rounded"
                              placeholder="Search by ID, keyword..." />
                          </div>
                        </div>

                        <hr class="my-2">

                        <!-- Status -->
                        <div class="mb-3">
                          <label class="text-xxs fw-600 text-uppercase text-muted mb-2 d-block">
                            Status
                          </label>

                          <div class="d-flex flex-wrap gap-1">
                            <span @click="filter_status = 'All'" class="badge rounded cursor-pointer text-xs"
                              :class="filter_status === 'All' ? 'status-active' : 'status-inactive'">
                              All
                            </span>

                            <span v-for="step in workflow_steps" :key="step.status" @click="filter_status = step.status"
                              class="badge rounded cursor-pointer text-xs"
                              :class="filter_status === step.status ? 'status-active' : 'status-inactive'">
                              {{ step.status }}
                            </span>
                          </div>
                        </div>

                        <hr class="my-2">

                        <!-- Incident Types -->
                        <div class="mb-3">
                          <label class="text-xxs fw-600 text-uppercase text-muted mb-2 d-block">
                            Incident Type
                          </label>

                          <div class="d-flex flex-wrap gap-1">
                            <span @click="filter_type = 'All'" class="badge rounded cursor-pointer text-xs"
                              :class="filter_type === 'All' ? 'status-active' : 'status-inactive'">
                              All
                            </span>

                            <span v-for="type in entity_types" :key="type.id"
                              @click="filter_type = type.entity_type_name" class="badge rounded cursor-pointer text-xs"
                              :class="filter_type === type.entity_type_name ? 'status-active' : 'status-inactive'">
                              {{ type.entity_type_name }}
                            </span>
                          </div>
                        </div>

                      </div>


                    </div>

                  </div>
                </div>
                <div v-if="show_map_view" class="incident-map-main">
                  <section class="incident-main-map-card card border shadow-sm rounded-3 p-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                      <div>
                        <div class="fw-bold text-sm text-dark">Incident Map</div>
                        <div class="text-muted text-xxs">{{ filtered_entries.length }} visible reports</div>
                      </div>
                      <button class="btn btn-sm btn-light incident-menu-btn" type="button" title="Back to reports"
                        @click="toggle_map">
                        <i class="bi bi-list-ul"></i>
                      </button>
                    </div>
                    <div id="incident-map" class="incident-map-container incident-map-container-main"></div>
                    <div class="incident-map-categories mt-3">
                      <button v-for="category in incident_category_counts" :key="category.name"
                        class="incident-map-category" type="button"
                        :class="{ 'is-active': filter_type === category.name }"
                        @click="select_map_category(category.name)">
                        <span class="incident-map-category-pin" :style="{ backgroundColor: category.color }"></span>
                        <span class="incident-map-category-name">{{ category.name }}</span>
                        <span class="incident-map-category-count">{{ category.count }}</span>
                      </button>
                    </div>
                  </section>
                </div>
                <div v-else>
                  <div v-if="loading && logged_entries.length === 0" class="incident-state-card card border shadow-sm rounded-3 text-center p-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <div class="mt-2 text-muted small">Fetching reports...</div>
                  </div>

                  <div v-else-if="filtered_entries.length === 0" class="rounded-3 text-center p-4">
                    <div class="incident-empty-feed-icon mb-3 mx-auto">
                      <i class="bi bi-search"></i>
                    </div>
                    <div class="fw-bold text-dark text-sm">No reports found</div>
                    <div class="small text-muted mt-1">Try adjusting your search or filters.</div>
                  </div>

                  <div v-else>
                    <div class="row g-3 justify-content-center">
                      <div v-for="r in filtered_entries" :key="r.id" class="col-12">
                        <article class="incident-report-card card border shadow-sm rounded-3 w-100 overflow-hidden h-100">

                          <!-- Top badges + remaining -->
                          <div class="incident-report-header d-flex justify-content-between align-items-start gap-3">
                            <div class="min-vw-0 d-flex align-items-start gap-3">
                              <div class="incident-report-type-icon flex-shrink-0">
                                <i class="bi bi-exclamation-octagon-fill"></i>
                              </div>
                              <div class="min-vw-0">
                                <div class="d-flex flex-wrap align-items-center gap-2 min-vw-0 mb-1">
                                  <span class="incident-id-chip">INC-{{ r.id }}</span>
                                  <span class="incident-type-chip">{{ r.entity_type?.entity_type_name || 'Incident'
                                    }}</span>
                                </div>
                                <div class="small text-muted d-flex align-items-center gap-1 text-nowrap">
                                  <i class="bi bi-clock-fill"></i>
                                  <span>{{ format_created_at(r.date_created) }}</span>
                                </div>
                              </div>
                            </div>

                            <div class="d-flex align-items-center gap-2 flex-shrink-0">
                              <div v-if="get_remaining_label(r)"
                                class="incident-remaining d-flex align-items-center gap-1">
                                <i class="bi bi-clock-history"></i>
                                <span class="text-nowrap">{{ get_remaining_label(r) }}</span>
                              </div>
                              <button class="btn btn-sm btn-light incident-menu-btn" type="button" aria-label="More"
                                @click.stop="toggle_activity(r.id)" :class="is_activity_open(r.id) ? 'is-open' : ''">
                                <i class="bi bi-chevron-down"></i>
                              </button>
                            </div>
                          </div>

                          <!-- Title + description -->
                          <div class="incident-report-body">
                            <div v-if="get_report_body(r)" class="incident-desc lh-base mb-3">
                              {{ get_report_body(r) }}
                            </div>
                            <div
                              class="d-flex flex-wrap align-items-center gap-3 small text-muted citizen-incident-meta">
                              <span v-if="r.location" class="d-flex align-items-center gap-1 min-vw-0">
                                <i class="bi bi-geo-alt-fill text-danger"></i>
                                <span>{{ r.location }}</span>
                              </span>
                              <span class="d-flex align-items-center gap-1 text-nowrap">
                                <i class="bi bi-person-fill"></i>
                                <span>{{ get_assigned_name(r) }}</span>
                              </span>
                            </div>
                          </div>

                          <!-- Current status (compact) -->
                          <div class="incident-current-status d-flex align-items-center justify-content-between gap-2">
                            <div class="d-flex align-items-center gap-2">
                              <span class="d-inline-block incident-dot" :class="get_current_dot_class(r)"></span>
                              <span class="small fw-semibold">{{ get_current_status_label(r) }}</span>
                            </div>
                            <div v-if="get_attachment_count(r)"
                              class="small text-muted d-flex align-items-center gap-1">
                              <i class="bi bi-paperclip"></i>
                              <span>{{ get_attachment_count(r) }}</span>
                            </div>
                          </div>

                          <!-- Social action row -->
                          <div class="incident-social-row border-top px-2 py-1">
                            <div class="row g-0 align-items-center">
                              <div class="col-4">
                                <button type="button" class="incident-social-action"
                                  :class="{ 'is-liked': is_incident_liked(r.id) }"
                                  @click.stop="toggle_incident_like(r)">
                                  <i class="bi" :class="is_incident_liked(r.id) ? 'bi-heart-fill' : 'bi-heart'"></i>
                                  <span>{{ get_incident_like_count(r) }}</span>
                                </button>
                              </div>

                              <div class="col-4">
                                <button type="button" class="incident-social-action"
                                  @click.stop="toggle_comment_panel(r.id)">
                                  <i class="bi bi-chat"></i>
                                  <span>{{ get_incident_comment_count(r) }}</span>
                                </button>
                              </div>

                              <div class="col-4 position-relative">
                                <button type="button" class="incident-social-action"
                                  @click.stop="toggle_share_menu(r.id)">
                                  <i class="bi bi-share"></i>
                                  <span>Share</span>
                                </button>

                                <div v-if="is_share_menu_open(r.id)" class="incident-share-popover shadow-sm"
                                  @click.stop>
                                  <button type="button" class="incident-share-item" @click="copy_incident_link(r)">
                                    <i class="bi bi-link-45deg text-primary"></i>
                                    <span>Copy link</span>
                                  </button>
                                  <a class="incident-share-item" target="_blank"
                                    :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(get_incident_url(r))">
                                    <i class="bi bi-facebook text-primary"></i>
                                    <span>Facebook</span>
                                  </a>
                                  <a class="incident-share-item" target="_blank"
                                    :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(get_incident_url(r))">
                                    <i class="bi bi-whatsapp text-success"></i>
                                    <span>WhatsApp</span>
                                  </a>
                                  <a class="incident-share-item" target="_blank"
                                    :href="'mailto:?subject=Incident%20Report&body=' + encodeURIComponent(get_incident_url(r))">
                                    <i class="bi bi-envelope text-secondary"></i>
                                    <span>Email</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Comments preview -->
                          <div v-if="is_comment_panel_open(r.id)" class="incident-comment-panel mx-3 mb-3">
                            <div v-if="get_incident_comments(r).length" class="incident-comment-list">
                              <div v-for="comment in get_incident_comments(r).slice(0, 3)"
                                :key="comment.id || comment.created_at || comment.comment_text"
                                class="incident-comment-item">
                                <div class="incident-comment-avatar">{{ get_comment_initials(comment) }}</div>
                                <div class="incident-comment-bubble">
                                  <div class="d-flex align-items-center justify-content-between gap-2">
                                    <div class="fw-bold text-xs">{{ get_comment_author(comment) }}</div>
                                    <div v-if="can_manage_comment(comment)"
                                      class="d-flex align-items-center gap-1 flex-shrink-0">
                                      <button v-if="!is_comment_editing(comment)" type="button"
                                        class="btn btn-link btn-sm p-0 text-muted text-xs" title="Edit comment"
                                        :disabled="is_comment_action_loading(comment.id)"
                                        @click.stop="start_edit_incident_comment(comment)">
                                        <i class="bi bi-pencil-square"></i>
                                      </button>
                                      <button type="button" class="btn btn-link btn-sm p-0 text-danger text-xs"
                                        title="Delete comment" :disabled="is_comment_action_loading(comment.id)"
                                        @click.stop="delete_incident_comment(r, comment)">
                                        <i class="bi bi-trash"></i>
                                      </button>
                                    </div>
                                  </div>
                                  <div v-if="is_comment_editing(comment)" class="d-flex align-items-center gap-1 mt-1">
                                    <input class="form-control form-control-sm rounded-pill incident-comment-input"
                                      type="text" v-model="editing_comment_drafts[comment.id]"
                                      @keyup.enter="submit_edit_incident_comment(r, comment)"
                                      @keyup.esc="cancel_edit_incident_comment" />
                                    <button type="button"
                                      class="btn btn-sm btn-primary rounded-circle incident-send-btn"
                                      :disabled="is_comment_action_loading(comment.id)"
                                      @click.stop="submit_edit_incident_comment(r, comment)">
                                      <i class="bi bi-check-lg"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-light rounded-circle incident-send-btn"
                                      :disabled="is_comment_action_loading(comment.id)"
                                      @click.stop="cancel_edit_incident_comment">
                                      <i class="bi bi-x-lg"></i>
                                    </button>
                                  </div>
                                  <div v-else class="text-muted text-xs">{{ get_comment_text(comment) }}</div>
                                </div>
                              </div>
                            </div>
                            <div v-else class="text-muted text-xs py-2">
                              No comments yet.
                            </div>

                            <div class="d-flex align-items-center gap-2 mt-2">
                              <input class="form-control form-control-sm rounded-pill incident-comment-input"
                                type="text" v-model="comment_drafts[r.id]" placeholder="Write a comment..."
                                @keyup.enter="submit_incident_comment(r)" />
                              <button class="btn btn-sm btn-primary rounded-circle incident-send-btn" type="button"
                                @click="submit_incident_comment(r)">
                                <i class="bi bi-send-fill"></i>
                              </button>
                            </div>
                          </div>

                          <!-- Audit trail (expanded) -->
                          <div v-if="is_activity_open(r.id)" class="mx-3 mt-2 pt-2 pb-3 incident-trail">
                            <div class="incident-trail-title small text-uppercase fw-bold text-muted mb-2">
                              Audit Trail
                            </div>

                            <div class="incident-trail-body">
                              <div class="incident-trail-line"></div>

                              <div class="incident-trail-item is-done">
                                <div class="incident-trail-icon d-flex align-items-center justify-content-center">
                                  <i class="bi bi-check-lg"></i>
                                </div>
                                <div class="incident-trail-content">
                                  <div class="incident-trail-label fw-semibold">Submitted</div>
                                  <div class="incident-trail-time text-muted">{{ format_time(r.date_created) }}</div>
                                </div>
                              </div>

                              <div v-for="(step, index) in workflow_display_steps" :key="step.key"
                                class="incident-trail-item" :data-step="step.key" :class="get_step_class(r, index)">
                                <div class="incident-trail-icon">
                                  <i v-if="index < get_display_step_index(r)" class="bi bi-check-lg"></i>
                                  <i v-else :class="step.icon"></i>
                                </div>
                                <div class="incident-trail-content">
                                  <div class="incident-trail-label fw-semibold">{{ step.label }}</div>
                                  <div v-if="index === get_display_step_index(r)"
                                    class="incident-trail-time text-muted">
                                    {{ format_time(r.date_created) }}
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>

                        </article>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </section>


</div>
<!-- Create Report Modal -->
<div class="modal fade incident-modal" id="incidentModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">

      <!-- LEFT SIDEBAR -->
      <div class="left-panel">
        <div class="left-header">
          <div class="tag-p">Incident logging</div>
          <div class="incident-modal-note">Choose the type that best matches the report.</div>
        </div>
        <div class="cat-label">Incident Type</div>

        <!-- Sidebar entity buttons -->
        <div class="type-list">
          <button v-for="type in entity_types" :key="type.id" class="type-btn"
            :class="selected_type_id === type.id ? 'active' : ''" @click="selected_type_id = type.id">
            <div class="a-bar bg-secondary "></div>
            <div>
              <div class="t-name">{{ type.entity_type_name }}</div>
              <div class="t-sub">{{ type.sub || '' }}</div>
            </div>

          </button>
        </div>
      </div>

      <!-- RIGHT PANEL -->
      <div class="right-panel"
        :style="{ '--accent': (entity_types.find(e => e.id === selected_type_id)?.color || '#C0392B') }">

        <!-- Topbar -->
        <div class="modal-topbar" v-if="!success_screen">
          <div class="d-flex align-items-center">
            <div class="incident-modal-icon me-3">
              <i class="bi bi-clipboard2-plus-fill"></i>
            </div>
            <div>
              <div class="topbar-name ">
                {{ selected_type_id ? entity_types.find(e => e.id === selected_type_id)?.entity_type_name : 'New Incident' }}
              </div>
              <div class="topbar-desc ">
                {{ selected_type_id ? 'Complete the required details and submit the report.' : 'Choose an incident type to start logging.' }}
              </div>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div v-if="!success_screen" class="form-scroll">
          <!-- EMPTY STATE -->
          <div v-if="!selected_type_id" class="empty-notice">
            <div class="incident-empty-icon mb-3">
              <i class="bi bi-list-check"></i>
            </div>
            <div class="fw-bold mb-1">Choose an Incident Type</div>
            <div class="small text-primary mb-3">
              Select from the sidebar or pick a type below to load the right form.
            </div>

            <!-- Quick pick grid -->
            <div class="type-grid px-2 pb-4">
              <button v-for="type in entity_types" :key="type.id" class="tg-item"
                :class="selected_type_id === type.id ? 'active' : ''" @click="selected_type_id = type.id"
                :style="{ '--tc': type.color || '#C0392B', '--tbg': type.bg || '#fff5f5' }">
                <span class="tg-lbl">{{ type.entity_type_name }}</span>
              </button>
            </div>
          </div>

          <!-- FORM -->
          <div v-if="selected_type_id">
            <div v-for="section in form_schema" :key="section.id" class="form-section">
              <div class="sec-head">
                <div class="sec-ico">
                  <i class="bi bi-card-checklist"></i>
                </div>
                <div>
                  <div class="sec-title">{{ section.name }}</div>
                  <div class="sec-sub">{{ section.sub }}</div>
                </div>
              </div>
              <div class="sec-body">
                <div class="row g-3">
                  <div class="col-12" v-for="q in section.questions" :key="q.section_question_id">


                    <div
                      v-if="q.question_type.question_type === 'short_text' && q.question_text.toLowerCase().includes('location')">
                      <label class="incident-field-label">{{ q.question_text }}</label>
                      <input :id="'search-input-' + q.section_question_id" type="text"
                        class="form-control border rounded mb-2" v-model="form_data[q.section_question_id]"
                        placeholder="Search for a location..." />

                      <div :id="'map-' + q.section_question_id" class="rounded-4 mb-3 d-none location-map"></div>
                    </div>

                    <!-- SHORT TEXT -->
                    <div v-else-if="q.question_type.question_type === 'short_text'">
                      <label class="incident-field-label">{{ q.question_text }}</label>
                      <input type="text" class="form-control border rounded"
                        v-model="form_data[q.section_question_id]" />
                    </div>



                    <!-- LONG TEXT -->
                    <div v-else-if="q.question_type.question_type === 'long_text'">
                      <label class="incident-field-label">{{ q.question_text }}</label>
                      <textarea class="form-control" v-model="form_data[q.section_question_id]"></textarea>
                    </div>

                    <!-- SELECT -->
                    <div v-else-if="q.question_type.question_type === 'select'">
                      <label class="incident-field-label">{{ q.question_text }}</label>
                      <select class="form-select" v-model="form_data[q.section_question_id]">
                        <option value="">Select...</option>
                        <option v-for="opt in q.multi_select_choices" :key="opt.id" :value="opt.value">
                          {{ opt.value }}
                        </option>
                      </select>
                    </div>

                    <!-- FILE UPLOAD -->
                    <div v-else-if="q.question_type.question_type === 'file'">
                      <label class="incident-field-label">{{ q.question_text }}</label>



                      <div
                        class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center transition-all position-relative"
                        :class="isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
                        @dragover.prevent="isDragging = true" @dragenter.prevent="isDragging = true"
                        @dragleave.prevent="isDragging = false"
                        @drop.prevent="handle_file_upload($event, q.section_question_id)" @click="trigger_file_input">
                        <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                          <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                          <span class="fw-bold text-black text-sm">Drag & Drop media here or click</span>
                        </div>

                        <input type="file" ref="fileInput" class="d-none" multiple
                          @change="handle_file_upload($event, q.section_question_id)">
                      </div>

                      <div v-if="form_data[q.section_question_id] && form_data[q.section_question_id].length > 0"
                        class="mt-3 d-flex flex-wrap gap-3">

                        <div v-for="(file, index) in form_data[q.section_question_id]" :key="index"
                          class="incident-file-preview position-relative border rounded p-1 shadow-sm">

                          <img v-if="file.type && file.type.startsWith('image/')" :src="file.previewUrl"
                            class="w-100 h-100 rounded" :alt="file.name">

                          <button type="button"
                            class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0 fs-6 px-2 py-0"
                            @click="remove_file(q.section_question_id, index)">
                            &times;
                          </button>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Footer -->
        <div v-if="selected_type_id && !success_screen" class="modal-footer-bar d-flex justify-content-end">
          <button class="btn btn-sm btn-primary rounded" :disabled="is_submitting" @click="submit_incident">
            <span>{{ is_submitting ? "Submitting..." : "Submit Report" }}</span>
          </button>
        </div>

        <!-- SUCCESS SCREEN -->
        <div v-if="success_screen" class="success-screen">
          <div class="success-icon bg-success text-white">
            <i class="bi bi-check-lg"></i>
          </div>
          <div class="h4 fw-bold mb-1">Report Submitted!</div>
          <div class="text-primary mb-2">Your reference number</div>
          <div class="ref-badge">INC - {{ reference_number }}</div>
          <p class="text-primary mb-4 success-paragraph">
            Confirmation sent to your email. The relevant team has been notified.
          </p>
          <div class="d-flex justify-content-center gap-2">
            <button class="btn btn-sm bg-primary mt-2 text-xs rounded text-white" @click="reset_modal">New
              Report</button>
            <button class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
